import { useMemo, useState } from 'react'
import { Search, X } from 'lucide-react'
import type { DictionaryIngredient } from '@entities/calculator'
import { quantShort } from '@entities/calculator'
import { useOverlayBack } from './overlayBack'

interface IngredientPickerSheetProps {
  ingredients: readonly DictionaryIngredient[]
  /** Идентификаторы уже добавленных — подписываем, а не скрываем. */
  usedIds: ReadonlySet<number>
  onPick: (ingredient: DictionaryIngredient) => void
  onClose: () => void
}

/**
 * Выбор продукта из справочника. Порядок как пришёл с бэка — его задаёт
 * админка, пересортировка ломает привычные группы.
 */
const IngredientPickerSheet = ({
  ingredients,
  usedIds,
  onPick,
  onClose,
}: IngredientPickerSheetProps) => {
  const [query, setQuery] = useState('')

  useOverlayBack(onClose)

  const filtered = useMemo(() => {
    const needle = query.trim().toLowerCase()
    if (!needle) return ingredients
    return ingredients.filter(item => item.name.toLowerCase().includes(needle))
  }, [ingredients, query])

  return (
    <div className="cost-sheet" role="dialog" aria-modal="true">
      <div className="cost-sheet__head">
        <h2>Выберите продукт</h2>
        <button type="button" onClick={onClose} aria-label="Закрыть">
          <X size={20} />
        </button>
      </div>

      <label className="cost-sheet__search">
        <Search size={18} aria-hidden />
        {/* Фокус не ставим: в Telegram клавиатура выехала бы сразу и закрыла
            половину списка, хотя человек пришёл смотреть, а не искать. */}
        <input
          type="search"
          value={query}
          onChange={event => setQuery(event.target.value)}
          placeholder="Поиск по названию"
        />
      </label>

      <div className="cost-sheet__list">
        {filtered.map(ingredient => (
          <button
            key={ingredient.ingredient_id}
            type="button"
            className="cost-sheet__item"
            onClick={() => onPick(ingredient)}
          >
            <span className="cost-sheet__item-name">{ingredient.name}</span>
            <span className="cost-sheet__item-unit">
              {usedIds.has(ingredient.ingredient_id)
                ? 'цена указана'
                : quantShort(ingredient.quant)}
            </span>
          </button>
        ))}

        {filtered.length === 0 && (
          <p className="cost-sheet__empty">
            По запросу «{query}» продуктов не нашлось
          </p>
        )}
      </div>
    </div>
  )
}

export default IngredientPickerSheet
